module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 4\"><rect width=\"24\" height=\"4\" fill=\"#AA2525\" rx=\"1\"></rect></svg>"